import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { getNotifications } from '../../services/notificationService';
import NotificationList from '../../components/notifications/NotificationList';
import NotificationFilter from '../../components/notifications/NotificationFilter';
import './Notifications.css';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    dateFrom: null,
    dateTo: null
  });
  
  useEffect(() => {
    fetchNotifications();
  }, [filters]);
  
  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const data = await getNotifications(filters);
      setNotifications(data);
      setError(null);
    } catch (err) {
      setError('Error al cargar notificaciones');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  
  const handleFilterChange = (newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  };
  
  return (
    <div className="notifications-container">
      <h1 className="page-title">Notificaciones</h1>
      
      <NotificationFilter 
        filters={filters} 
        onFilterChange={handleFilterChange} 
      />
      
      {loading ? (
        <div className="loading-state">
          <p>Cargando notificaciones...</p>
        </div>
      ) : error ? (
        <div className="error-state">
          <p>{error}</p>
          <button onClick={fetchNotifications}>Reintentar</button>
        </div>
      ) : (
        <NotificationList notifications={notifications} />
      )}
    </div>
  );
};

export default Notifications;